<template>
    <Card>
        <Form ref="form" :model="form" :rules="ruleValidate" :label-width="150">
            <FormItem label="标题" prop="title">
                <Input v-model="form.title" placeholder="" :maxlength="50" />
            </FormItem>
            <FormItem label="失效时间" prop="expirationTime" class="half">
                <DatePicker v-model="form.expirationTime" format="yyyy-MM-dd" type="date" placeholder="" ></DatePicker>
            </FormItem>
            <FormItem label="置顶" prop="istop" class="half">
                <i-switch v-model="form.istop" :true-value="1" :false-value="0"/>
            </FormItem>
            <div style="clear:both"></div>
            <FormItem label="内容" prop="content">
                <div id="content"></div>
            </FormItem>
            <FormItem>
                <Button type="primary" :loading="save.isSaving" @click="handleSubmit('form')">{{save.text}}</Button>
                <Button type="default" @click="closeMe" style="margin-left: 8px"> {{ $t('cancelText') }}</Button>
            </FormItem>
        </Form>
    </Card>
</template>
<script>
import Util from '@/libs/util.js'
import Editor from 'wangeditor'
export default {
  data () {
    return {
      form: {
        id: null,
        title: null,
        expirationTime: null,
        content: null,
        istop: 0,
        showContent: 'N'
      },
      ruleValidate: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' }
        ]
      },
      save: { isSaving: false, text: '提交' },
      editor: {}
    }
  },
  mounted () {
    this.editor = new Editor(`#content`)
    this.editor.customConfig.uploadImgServer = Util.baseUrl + '/api/system/cscpInformationIssuesUpload'
    this.editor.customConfig.uploadFileName = 'fileContent'
    this.editor.customConfig.uploadImgMaxSize = 10 * 1024 * 1024// 最大10M
    this.editor.customConfig.uploadImgMaxLength = 1// 只能上传一个图片
    this.editor.customConfig.uploadImgHeaders = {
      'Authorization': localStorage.getItem('token')
    }
    this.editor.customConfig.uploadImgHooks = {
      customInsert: function (insertImg, result, editor) {
        var url = result.data[0]
        insertImg(Util.baseUrl + '/infos/' + url)
      }
    }
    this.editor.create()
    this.init()
  },
  methods: {
    init () {
      let id = this.$route.params.id
      if (id && id != 0) {
        this.getItem(id)
      }
    },
    handleSubmit (name) {
      console.log('--------------')
      let id = this.$route.params.id
      this.form.content = this.editor.txt.html()
      this.form.showContent = this.editor.txt.text().length > 0 ? 'Y' : 'N'
      this.$refs[name].validate(valid => {
        if (valid) {
          this.save = { isSaving: true, text: '提交中,请稍候...' }
          if (id && id != 0) {
            this.updateItem(this.form)
          } else {
            this.createItem(this.form)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
        }
      })
    },
    getItem (id) {
      let self = this
      Util.http.get(`/api/system/cscpInformationIssues/${id}`).then(response => {
        self.form = response.data
        self.editor.txt.html(self.form.content)
      }).catch(error => {
        if (error.response.data.message) {
          self.$Notice.error({ title: '提示', desc: error.response.data.message })
        }
      })
    },
    createItem (postBody) {
      let self = this
      Util.http.post(`/api/system/cscpInformationIssues`, postBody).then(response => {
        self.$Message.success(self.$t('successText'))
        self.$router.push({
          name: 'information-issue'
        })
        self.closeMe()
      }).catch(error => {
        if (error.response.data.message) {
          self.$Notice.error({ title: '提示', desc: error.response.data.message })
        }
        self.save = { isSaving: false, text: '提交' }
      })
    },
    updateItem (putBody) {
      let self = this
      Util.http.put(`/api/system/cscpInformationIssues`, putBody).then(response => {
        self.$Message.success(self.$t('successText'))
        self.$router.push({
          name: 'information-issue'
        })
        self.closeMe()
      }).catch(error => {
        if (error.response.data.message) {
          self.$Notice.error({ title: '提示', desc: error.response.data.message })
        }
        self.save = { isSaving: false, text: '提交' }
      })
    },
    closeMe () {
      this.$store.commit('app/closePage', {
        vm: this,
        fromName: this.$route.name,
        toName: 'information_issue'
      })
    }
  },
  activated () {
    this.init()
  }
}
</script>
<style scoped>
.half{width: 50%;float: left;}
</style>
<style>
.ivu-select-dropdown{z-index: 10005;}
</style>
